export default "__VITE_ASSET__CSbfiOt2__"